// EXTERNAL DEPENDENCIES
import React from 'react'

// HELPERS
import { invokeOnSpaceOrEnter } from '@/utils'

// COMPONENTS
import { CameraIcon } from '@paypalcorp/pp-react'

// TEST IDS
import { COVER_PHOTO_IMAGE_OVERLAY_TEST_ID } from '@/constants/test-ids'

// STYLES
import { mainBrandPrimaryBlueText, whiteColor } from '@/styles/colors'
import styles from './styles.module.less'

/**
 * Rectangular photo overlay meant to indicate that
 * the photo is editable
 */
export function CoverPhotoOverlay({
  handleClick,
  isOwnerPhoto,
}: {
  handleClick: () => void
  isOwnerPhoto?: boolean
}) {
  return (
    <div
      className={styles.coverPhotoOverlayContainer}
      onClick={handleClick}
      onKeyDown={invokeOnSpaceOrEnter(handleClick)}
      role={handleClick ? 'button' : ''}
      aria-haspopup={!!handleClick}
      tabIndex={handleClick ? 0 : -1}
      data-testid={COVER_PHOTO_IMAGE_OVERLAY_TEST_ID}
    >
      <div
        className={
          isOwnerPhoto ? styles.ownerPhotoOverlay : styles.coverPhotoOverlay
        }
      >
        <div
          className={styles.cameraIconContainer}
          style={{ background: whiteColor }}
        >
          <CameraIcon
            className={styles.coverPhotoCameraIcon}
            color={mainBrandPrimaryBlueText}
          />
        </div>
      </div>
    </div>
  )
}
